import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, input, InputSignal } from '@angular/core';
import { IroNamRequestStatus } from '@shs-digi-care-monorepo/interfaces';
import { statusList } from './status-list.config';

@Component({
    selector: 'app-status-stepper',
    templateUrl: './status-stepper.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class StatusStepperComponent {
    public requestStatus: InputSignal<IroNamRequestStatus> = input<IroNamRequestStatus>(IroNamRequestStatus.SAVED);

    private readonly statusList = statusList;

    protected stepperValue = computed(() => {
        const index = this.statusList.findIndex((statusGroup) =>
            statusGroup.values.includes(this.requestStatus() ?? IroNamRequestStatus.SUBMITTED)
        );
        return index + 1;
    });
}
